<template>
  <div class="market-title">
    <div :class="noCursor ? '' : 'cursor'">
      <span
        :style="{ 'pointer-events': noCursor ? 'none' : '' }"
        @click="navigateReplace('coinToCoinAccount')"
        v-for="(item, index) in titles"
        :key="index"
        >{{ item }}</span
      >
    </div>
  </div>
</template>
<script>
import { coinToCoinAccountApi } from '../../api/coinToCoinAccount/coinToCoinAccountApi';
import GCToCTable from '../../components/GCToCTable';
export default {
  name: 'CoinToCoinAccountTitle',
  props: ['titles', 'noCursor'],
  components: { GCToCTable }
};
</script>
<style scoped>
.market-title {
  margin-top: 25px;
  font-size: 1.1rem;
  line-height: 40px;
  padding: 10px 10px;
  color: #8a909a;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 234, 240, 1);
  opacity: 1;
  border-radius: 2px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.market-title span {
  padding-right: 10px;
}
.market-title span::before {
  content: '';
  padding-right: 10px;
  color: #8a909a;
}
.market-title span:not(:first-child)::before {
  content: '>';
}
.market-title span:last-child {
  color: #262b3c;
  font-weight: 700;
}
@media screen and (max-width: 599px) {
  .market-title {
    font-size: 1rem;
    height: 45px;
    padding: 5px;
  }
  .market-title span {
    padding-right: 5px;
  }
}
</style>
